<script lang="tsx" setup>
import { KirbyPageData } from "@/queries"
import InternalLink from "@/components/Links/InternalLink.vue"
import { PathUtils } from "@/utils/path.utils"
import TextLabel from "../Text/TextLabel.vue"

defineProps<{
  programme: KirbyPageData
  year?: string
}>()
</script>

<template>
  <div>
    <TextLabel>Programme:</TextLabel>
    <InternalLink
      :to="PathUtils.checkUri(programme.uri)"
      :text="programme.title"
    />
    <div
      v-if="programme.title !== year && year !== 'Foundation'"
      v-html="year"
    />
  </div>
</template>
